
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicosPage from "../pages/servicos/page";
import PortfolioPage from "../pages/portfolio/page";
import DepoimentosPage from "../pages/depoimentos/page";
import SobrePage from "../pages/sobre/page";
import ContatoPage from "../pages/contato/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicos",
    element: <ServicosPage />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPage />,
  },
  {
    path: "/depoimentos",
    element: <DepoimentosPage />,
  },
  {
    path: "/sobre",
    element: <SobrePage />,
  },
  {
    path: "/contato",
    element: <ContatoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
